export default {
  title: 'Place Availability',
  list: 'List',
  kanban: 'Kanban',

  place: 'Place',
  status: 'Status',
  'status.available': 'Available',
  'status.unavailable': 'Unavailable',

  origin: 'Last change origin',
  'origin.non_compliance': 'Non-compliance',
  'origin.automation': 'Automation',
  'origin.manual': 'Manual',

  changedAt: 'Last changed at',
  responsible: 'Responsible',
  openNonCompliances: 'Open non-compliances',
  noResponsible: 'Automatic',
  neverChanged: 'Never changed',

  changeStatusManually: 'Change status manually',
  changeStatusTo: 'Change place status to',
  reason: 'Reason (optional)',
  reasonPlaceholder: 'Describe the reason for this change',
  confirmChangeStatus: 'Are you sure you want to change this place availability status?',
  changeStatusSuccess: 'Availability status changed successfully.',
  changeStatusError: 'An error occurred while changing the availability status.',

  filterByStatus: 'Availability status',
  filterByOrigin: 'Last change origin',

  moreOptions: 'More options',
  automations: 'Automations',

  'statusSourceConfig.buttonLabel': 'Settings',
  'statusSourceConfig.title': 'Availability Status Source',
  'statusSourceConfig.description':
    'Select where a place availability status can be updated from automatically.',
  'statusSourceConfig.nonCompliance': 'Non-compliance',
  'statusSourceConfig.automation': 'Automation',

  'tabs.details': 'Details',
  'tabs.history': 'History',

  'history.empty': 'There is no status change history for this place yet.',
  'history.lastChange': 'Last status change',
  'history.changedTo': 'Status changed to {{status}}',

  'openNonCompliancesList.title': 'Open non-compliances',
  'openNonCompliancesList.empty': 'This place has no open non-compliances.',

  'modals.changeAvailabilityStatus': 'Change availability status',
  'modals.availabilityDetails': 'Place availability'
}
